export function EthIcon() {
    return (
      <svg
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group 1171274766">
          <rect
            id="Rectangle 13537"
            width="58"
            height="58"
            rx="14"
            fill="white"
            fillOpacity="0.1"
          />
          <g id="Layer_x0020_1">
            <g id="_1421394342400">
              <g id="Group 370">
                <path
                  id="Path 364"
                  d="M28.705 16L28.537 16.572V33.172L28.705 33.34L36.405 28.786L28.705 16Z"
                  fill="white"
                />
                <path
                  id="Path 365"
                  d="M28.7 16L21 28.784L28.7 33.338V16Z"
                  fill="white"
                />
                <path
                  id="Path 366"
                  d="M28.705 35.884L28.61 36V41.913L28.705 42.19L36.486 30.454L28.705 35.884Z"
                  fill="white"
                />
                <path
                  id="Path 367"
                  d="M28.7 42.189V35.884L21 30.651L28.7 42.189Z"
                  fill="white"
                />
                <path
                  id="Path 368"
                  d="M28.705 33.93L36.387 28.868L28.705 25.874V33.93Z"
                  fill="white"
                />
                <path
                  id="Path 369"
                  d="M21.067 28.868L28.7 33.92V25.874L21.067 28.868Z"
                  fill="white"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
  
  export function TethIcon() {
    return (
      <svg
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group 1171274766">
          <rect
            id="Rectangle 13537"
            opacity="0.2"
            width="58"
            height="58"
            rx="14"
            fill="#51AF95"
          />
          <g id="Group 48971">
            <path
              id="Path 34105"
              d="M41.0804 27.683C40.9417 27.5187 40.7764 27.3787 40.5914 27.269C40.1078 26.9815 39.5892 26.7573 39.0484 26.602C37.9341 26.269 36.7947 26.0263 35.6414 25.876C34.3414 25.689 33.0324 25.576 31.7204 25.515C31.6204 25.515 31.6054 25.48 31.6054 25.391C31.6054 24.491 31.6054 23.583 31.6054 22.679C31.6054 22.536 31.6054 22.536 31.7454 22.536H38.2814C38.4084 22.536 38.4084 22.536 38.4084 22.41V18.128C38.4084 18 38.4084 18 38.2764 18H20.0184C19.8854 18 19.8854 18 19.8854 18.128V22.41C19.8854 22.536 19.8854 22.536 20.0124 22.536H26.5774C26.6374 22.536 26.6894 22.527 26.6894 22.622C26.6894 23.5553 26.6894 24.4917 26.6894 25.431C26.6894 25.486 26.6774 25.511 26.6144 25.513C26.3904 25.522 26.1664 25.536 25.9424 25.549C25.2191 25.5917 24.4971 25.6527 23.7764 25.732C23.1334 25.803 22.4924 25.889 21.8554 25.997C20.9021 26.1466 19.9617 26.3693 19.0424 26.663C18.532 26.818 18.0452 27.0421 17.5954 27.329C17.4074 27.4467 17.2459 27.6023 17.1214 27.786C17.0424 27.8988 17 28.0332 17 28.171C17 28.3088 17.0424 28.4432 17.1214 28.556C17.1905 28.6629 17.2751 28.7589 17.3724 28.841C17.6808 29.0924 18.0271 29.2932 18.3984 29.436C19.1582 29.7423 19.945 29.9766 20.7484 30.136C21.5104 30.301 22.2804 30.424 23.0534 30.525C23.5914 30.595 24.1314 30.653 24.6714 30.701C25.2994 30.757 25.9284 30.801 26.5584 30.831C26.6904 30.838 26.6904 30.841 26.6904 30.975V40.232C26.6904 40.365 26.6904 40.365 26.8204 40.365H31.4634C31.6234 40.365 31.6084 40.384 31.6084 40.218C31.6084 37.1453 31.6084 34.0727 31.6084 31C31.6084 30.968 31.6084 30.935 31.6084 30.9C31.6084 30.852 31.6224 30.828 31.6734 30.827C31.7244 30.826 31.7904 30.82 31.8484 30.817C32.3784 30.795 32.9064 30.757 33.4344 30.712C34.2184 30.646 34.9994 30.56 35.7774 30.445C36.7236 30.3139 37.6608 30.1242 38.5834 29.877C39.2266 29.7151 39.848 29.4768 40.4344 29.167C40.6774 29.0413 40.8951 28.8718 41.0764 28.667C41.2046 28.5355 41.2766 28.3594 41.2773 28.1758C41.2781 27.9922 41.2075 27.8155 41.0804 27.683ZM39.8614 28.398C39.5823 28.6228 39.2649 28.7952 38.9244 28.907C38.1656 29.1776 37.3837 29.3784 36.5884 29.507C35.7344 29.663 34.8734 29.77 34.0104 29.853C33.2274 29.928 32.4424 29.975 31.6564 30.018C30.6424 30.073 29.6284 30.074 28.6944 30.073C27.4734 30.06 26.3334 30.019 25.1944 29.933C24.055 29.8545 22.9203 29.719 21.7944 29.527C20.9046 29.3914 20.0315 29.1628 19.1894 28.845C18.9652 28.7574 18.7512 28.6454 18.5514 28.511C18.4568 28.4477 18.371 28.3721 18.2964 28.286C18.2496 28.2405 18.2124 28.1861 18.187 28.126C18.1616 28.0659 18.1485 28.0013 18.1485 27.936C18.1485 27.8707 18.1616 27.8061 18.187 27.746C18.2124 27.6859 18.2496 27.6315 18.2964 27.586C18.4453 27.4214 18.6254 27.2881 18.8264 27.194C19.3519 26.9368 19.9062 26.7431 20.4774 26.617C21.5015 26.3732 22.5404 26.1962 23.5874 26.087C24.5794 25.973 25.5734 25.898 26.5704 25.851C26.6704 25.851 26.6884 25.874 26.6884 25.967C26.6884 26.994 26.6884 28.022 26.6884 29.049C26.6884 29.143 26.7084 29.172 26.8094 29.178C28.2217 29.2592 29.6372 29.2689 31.0504 29.207C31.2034 29.201 31.3504 29.181 31.5074 29.178C31.5934 29.178 31.6074 29.141 31.6074 29.066C31.6074 28.881 31.6074 28.695 31.6074 28.51V25.981C31.6074 25.857 31.6074 25.855 31.7354 25.861C32.6021 25.8997 33.4641 25.9637 34.3214 26.053C35.3499 26.1525 36.3718 26.31 37.3824 26.525C38.0297 26.6529 38.6615 26.849 39.2674 27.11C39.4842 27.2013 39.6864 27.3239 39.8674 27.474C39.9461 27.523 40.011 27.5913 40.0557 27.6725C40.1005 27.7537 40.1236 27.845 40.123 27.9377C40.1224 28.0304 40.0981 28.1214 40.0523 28.202C40.0065 28.2825 39.9408 28.35 39.8614 28.398Z"
              fill="#51AF95"
            />
          </g>
        </g>
      </svg>
    );
  }

  export const TronIcon = ({ width = "58", height = "58", fill = "#FF0000" }) => (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 61.000000 64.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
        fill={fill} // Change fill to the desired red color
        stroke="none"
      >
        <path d="M15 621 c29 -84 241 -611 245 -610 3 0 82 95 176 210 l171 210 -61 59 -61 59 -238 43 c-198 37 -237 42 -232 29z m275 -66 c79 -14 146 -28 148 -29 2 -2 -27 -29 -64 -60 -56 -46 -70 -53 -83 -43 -51 39 -191 159 -191 164 0 3 10 3 23 0 12 -3 87 -17 167 -32z m-105 -82 c71 -59 105 -94 105 -108 0 -31 -31 -259 -35 -264 -3 -2 -8 5 -11 15 -4 10 -43 109 -87 219 -43 110 -81 206 -84 213 -10 23 8 12 112 -75z m334 3 c29 -30 31 -35 15 -39 -43 -12 -154 -29 -165 -25 -10 3 95 98 110 98 4 0 22 -15 40 -34z m19 -77 c-6 -17 -241 -300 -245 -295 -4 4 25 257 30 263 2 1 189 39 210 42 5 1 7 -4 5 -10z"/>
      </g>
    </svg>
  );

  
  export function BitcoinIcon() {
    return (
      <svg
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group 1171274766">
          <rect
            id="Rectangle 13537"
            width="58"
            height="58"
            rx="14"
            fill="#F7931A"
            fillOpacity="0.2"
          />
          <g id="Group 20">
            <path
              id="Path 87"
              d="M35.764 28.149C36.5663 27.6966 37.2101 27.0086 37.6083 26.1781C38.0064 25.3476 38.1397 24.4148 37.99 23.506C37.609 20.633 34.184 19.548 31.482 19.32V15H28.818V19.281H27.03V15H24.366V19.281H19V22.04H21C21.894 22.04 22.332 22.306 22.332 23.029V34.884C22.332 35.873 21.837 36.178 21.304 36.178H19.268V39H24.444V43.376H27.127V39H28.91V43.376H31.517V39H32.088C37.568 39 39.395 36.317 39.395 32.664C39.3746 31.6157 39.0071 30.6038 38.3501 29.7868C37.693 28.9698 36.7835 28.3938 35.764 28.149ZM27.03 22.212H28.93C30.262 22.212 32.888 22.44 32.888 24.612C32.9319 25.2936 32.7143 25.9662 32.2795 26.493C31.8447 27.0197 31.2255 27.3609 30.548 27.447H27.028L27.03 22.212ZM29.979 35.912V35.893H27.03V30.185H30.455C31.255 30.185 34.261 30.451 34.261 32.585C34.261 34.719 32.833 35.912 29.979 35.912Z"
              fill="#F7931A"
            />
          </g>
        </g>
      </svg>
    );
  }

  export function PhoneIcon() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="216.582" height="135.261" viewBox="0 0 216.582 135.261">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rectangle_54610" dataName="Rectangle 54610" width="190.155" height="127.796" fill="none" />
          </clipPath>
        </defs>
        <g id="Group_150847" dataName="Group 150847" transform="translate(-114.23 -120.739)">
          <g id="Group_150841" dataName="Group 150841" transform="translate(119 127.204)">
            <rect id="Rectangle_54609" dataName="Rectangle 54609" width="123.486" height="83.521" transform="translate(66.67 44.275)" fill="#ffe1aa" />
            <g id="Group_150840" dataName="Group 150840">
              <g id="Group_150839" dataName="Group 150839" clip-path="url(#clip-path)">
                <path id="Path_104310" dataName="Path 104310" d="M96.707,64.223l57.96,52.882a5.612,5.612,0,0,0,7.566,0l57.96-52.882Z" transform="translate(-30.037 -19.948)" />
                <path id="Path_104311" dataName="Path 104311" d="M248.01,156.34,186.267,91.9l61.743,58.954Z" transform="translate(-57.855 -28.544)" />
                <path id="Path_104312" dataName="Path 104312" d="M96.707,156.34,158.45,91.9,96.707,150.853Z" transform="translate(-30.037 -28.544)" />
                <path id="Path_104313" dataName="Path 104313" d="M96.707,64.223l57.071,48.216a7.239,7.239,0,0,0,9.343,0l57.071-48.216Z" transform="translate(-30.037 -19.948)" fill="#ffc854" />
                <path id="Path_104314" dataName="Path 104314" d="M53.585,89.418A10.9,10.9,0,0,0,67.3,92.893l8.726-4.3a3.619,3.619,0,0,1,4.653,1.3l15.772,24.782a3.616,3.616,0,0,1-1.266,5.092c-5.1,2.886-15.636,7.768-27.235,6.823-16.281-1.326-26.882-16.466-44.812-44.639S-4.018,37.766,1.675,22.454C5.731,11.545,14.616,4.068,19.389.67a3.616,3.616,0,0,1,5.149,1.009L40.31,26.46a3.619,3.619,0,0,1-.79,4.768l-7.591,6.083a10.9,10.9,0,0,0-2.66,13.9Z" transform="translate(0 0)" fill="#787878" />
                <path id="Path_104315" dataName="Path 104315" d="M39.194,36.351l6.39-5.121a3.619,3.619,0,0,0,.79-4.768l-8.338-13.1L30.5,1.557A3.608,3.608,0,0,0,25.453.672a58.9,58.9,0,0,0-5.93,4.851Z" transform="translate(-6.064 -0.002)" fill="#171717" />
                <path id="Path_104316" dataName="Path 104316" d="M119.2,162.831a58.966,58.966,0,0,0,6.9-3.317,3.607,3.607,0,0,0,1.347-4.931l-16.206-25.4a3.614,3.614,0,0,0-4.3-.848l-7.419,3.657Z" transform="translate(-30.911 -39.747)" fill="#171717" />
              </g>
            </g>
          </g>
          <g id="Group_6650" dataName="Group 6650" transform="translate(159.131 120.739)">
            <path id="Path_2370" dataName="Path 2370" d="M128.5,82.585c0,5.552-3.721,10.056-8.305,10.056h0c4.584,0,8.305,4.5,8.305,10.052,0-5.552,3.717-10.052,8.305-10.052h0C132.214,92.641,128.5,88.137,128.5,82.585Z" transform="translate(-120.192 -67.814)" fill="#fff" />
            <path id="Path_2371" dataName="Path 2371" d="M134,80.82c0,5.552-3.721,10.052-8.305,10.052h0c4.584,0,8.305,4.5,8.305,10.056,0-5.552,3.717-10.056,8.305-10.056h0C137.718,90.872,134,86.372,134,80.82Z" transform="translate(-102.528 -73.479)" fill="#fff" />
            <path id="Path_2372" dataName="Path 2372" d="M128.074,86.761c0,2.631-1.764,4.765-3.936,4.765h0c2.172,0,3.936,2.13,3.936,4.761,0-2.631,1.759-4.761,3.931-4.761h0C129.833,91.526,128.074,89.392,128.074,86.761Z" transform="translate(-107.528 -54.412)" fill="#fff" />
            <path id="Path_2373" dataName="Path 2373" d="M127.918,79.076c0,3.363-2.252,6.087-5.026,6.087h0c2.774,0,5.026,2.723,5.026,6.087,0-3.363,2.252-6.087,5.026-6.087h0C130.17,85.163,127.918,82.439,127.918,79.076Z" transform="translate(-111.527 -79.076)" fill="#fff" />
          </g>
          {/* <g id="Group_150846" dataName="Group 150846" transform="translate(100.09 125.818)">
            <line id="Line_234" dataName="Line 234" x2="11.859" transform="translate(217.863 129.182)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
            <line id="Line_235" dataName="Line 235" x1="7.175" transform="translate(15.14 129.182)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
            <line id="Line_236" dataName="Line 236" x1="6.141" transform="translate(25.067 129.182)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
            <line id="Line_237" dataName="Line 237" x1="181.106" transform="translate(33.967 129.182)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
          </g> */}
        </g>
      </svg>
    )
  }
  export function MailIcon() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="17.291" height="11.672" viewBox="0 0 17.291 11.672">
        <path id="Icon_zocial-email" fill="#fff" dataName="Icon zocial-email" d="M.072,14.706V5.1q0-.017.05-.317L5.775,9.621.139,15.04a1.413,1.413,0,0,1-.067-.333ZM.822,4.118a.719.719,0,0,1,.283-.05H16.329a.944.944,0,0,1,.3.05L10.96,8.97l-.75.6L8.726,10.788,7.242,9.571l-.75-.6ZM.839,15.69l5.686-5.453,2.2,1.784,2.2-1.784,5.686,5.453a.8.8,0,0,1-.283.05H1.106a.755.755,0,0,1-.267-.05ZM11.677,9.621l5.636-4.836a1,1,0,0,1,.05.317v9.6a1.278,1.278,0,0,1-.05.333Z"
          transform="translate(-0.072 -4.068)" />
      </svg>
    )
  }
  
  export function PhoneNewIcon() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="10.193" height="16.309" viewBox="0 0 10.193 16.309">
        <path id="Icon_awesome-mobile" fill="#fff" dataName="Icon awesome-mobile" d="M8.664,0H1.529A1.529,1.529,0,0,0,0,1.529V14.78a1.529,1.529,0,0,0,1.529,1.529H8.664a1.529,1.529,0,0,0,1.529-1.529V1.529A1.529,1.529,0,0,0,8.664,0ZM5.1,15.29a1.019,1.019,0,1,1,1.019-1.019A1.018,1.018,0,0,1,5.1,15.29Z" />
      </svg>
    )
  }